import { IRootScopeService, IScope } from "angular";

export enum NavigationEventType {
  FULL_NAVIGATION_LOADED = "fullNavigationLoaded",
  NAVIGATION_LOADED = "mainNavigationLoaded",
  NAVIGATION_TOGGLED = "navigationToggled",
  SUBNAVIGATION_LOADED = "subNavigationLoaded",
}

interface INavigationToggledArgs {
  hideMenu: boolean;
}

export class NavigationEvents {
  private $rootScope: IRootScopeService;

  constructor(private $scope: IScope) {
    this.$rootScope = this.$scope.$root;
  }

  broadcastFullNavigationLoaded(): void {
    this.$rootScope.$broadcast(NavigationEventType.FULL_NAVIGATION_LOADED);
  }

  broadcastNavigationLoaded(): void {
    this.$rootScope.$broadcast(NavigationEventType.NAVIGATION_LOADED);
  }

  onFullNavigationLoaded(callback: () => unknown): void {
    this.$scope.$on(NavigationEventType.FULL_NAVIGATION_LOADED, callback);
  }

  onNavigationLoaded(callback: () => unknown): void {
    this.$scope.$on(NavigationEventType.NAVIGATION_LOADED, callback);
  }

  onSubNavigationLoaded(callback: () => unknown): void {
    this.$scope.$on(NavigationEventType.SUBNAVIGATION_LOADED, callback);
  }

  broadcastNavigationToggled(args: INavigationToggledArgs): void {
    this.$rootScope.$broadcast(NavigationEventType.NAVIGATION_TOGGLED, args);
  }

  onNavigationToggled(callback: (args: INavigationToggledArgs) => unknown): void {
    this.$scope.$on(NavigationEventType.NAVIGATION_TOGGLED, (evt, args: INavigationToggledArgs) => callback(args));
  }
}
